import React from 'react';
import { FiUsers, FiFileText, FiCheck, FiDollarSign } from 'react-icons/fi';

interface FunnelStepProps {
  icon: React.ReactNode;
  label: string;
  value: number;
  percentage: number;
  color: string;
}

const FunnelStep: React.FC<FunnelStepProps> = ({ icon, label, value, percentage, color }) => {
  return (
    <div className="relative mb-4">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center space-x-3">
          <div className={`p-2 rounded-full ${color}`}>
            {icon}
          </div>
          <span className="text-slate-700 font-medium">{label}</span>
        </div>
        <div className="text-right">
          <div className="text-lg font-bold text-slate-800">{value.toLocaleString()}</div>
          <div className="text-sm text-slate-500">{percentage}%</div>
        </div>
      </div>
      <div className="w-full bg-slate-200 rounded-full h-3">
        <div 
          className={`h-3 rounded-full transition-all duration-500 ${color.replace('bg-', 'bg-').replace('/20', '')}`}
          style={{ width: `${percentage}%` }}
        ></div>
      </div>
    </div>
  );
};

const LoanFunnelChart: React.FC = () => {
  const funnelData = [
    {
      icon: <FiUsers className="text-blue-600" size={16} />,
      label: 'Inquiries',
      value: 2450,
      percentage: 100,
      color: 'bg-blue-100'
    },
    {
      icon: <FiFileText className="text-indigo-600" size={16} />,
      label: 'Applications',
      value: 1420,
      percentage: 58,
      color: 'bg-indigo-100'
    },
    {
      icon: <FiCheck className="text-green-600" size={16} />,
      label: 'Approved',
      value: 980,
      percentage: 40,
      color: 'bg-green-100'
    },
    {
      icon: <FiDollarSign className="text-emerald-600" size={16} />,
      label: 'Funded',
      value: 618,
      percentage: 25.2,
      color: 'bg-emerald-100'
    }
  ];

  return (
    <div className="space-y-4">
      {funnelData.map((step, index) => (
        <FunnelStep key={index} {...step} />
      ))}
      
      {/* Summary Stats */}
      <div className="mt-6 pt-4 border-t border-slate-200">
        <div className="grid grid-cols-2 gap-4 text-center">
          <div>
            <div className="text-2xl font-bold text-slate-800">25.2%</div>
            <div className="text-sm text-slate-500">Conversion Rate</div>
          </div>
          <div>
            <div className="text-2xl font-bold text-green-600">+1.8%</div>
            <div className="text-sm text-slate-500">vs Last Quarter</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoanFunnelChart;